export default __webpack_public_path__ + "static/media/monthly-raffle.8031c4dc.svg";